/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Not_NowInputs */



/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Upgrade_Not_NowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upgrade_not_now = /** @type {((inputs?: Upgrade_Not_NowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Not_NowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas maintenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht jetzt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non ora")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не сейчас")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ahora no")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂不")
	if (locale === "ja") return /** @type {LocalizedString} */ ("今はしない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Agora não")
	return /** @type {LocalizedString} */ ("Not now")
});